export default __webpack_public_path__ + "static/media/2cha.edcfc43b.svg";